import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import { FaTools } from 'react-icons/fa';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import About from './Components/About';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Carousel from './Components/Carousel';
import comprepressureImg from './assets/Compressure.png';
import fertilizerImg from './assets/fertilizer.png';
import tankImg from './assets/tank.png';
import TechnologyInnovation from './Components/technology-innovation';
import digisterImg from './assets/digister.png';

function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Carousel />
              <main>
                <section id="home">
                  <Home />
                </section>
                <section id="about">
                  <About />
                </section>
                {/* Parallax CTA section */}
                <section className="parallax-cta" aria-label="Call to Action">
                  <div className="parallax-cta__overlay"></div>
                  <div className="parallax-cta__content">
                    <h2 className='text-white'>Call To Action</h2>
                    <p>Switch to affordable, low‑pressure CBG without heavy infrastructure. Built for MSMEs and rural industries.</p>
                    <a href="#contact" className="btn btn-outline-light btn-lg">Call To Action</a>
                  </div>
                </section>
                <section id="products" className="py-5 mb-5 bg-light">
                  <div className="container">
                    <div className="text-center mb-5">
                      <h2 className="fw-bold">Our Products</h2>
                      <p className="text-muted mb-0">Reliable, affordable solutions tailored for MSMEs and rural industries.</p>
                    </div>
                    <div className="row g-4">
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm">
                          <img src={digisterImg} className="card-img-top" alt="CBG Cylinders" loading="lazy" style={{ height: 220, objectFit: 'cover', width: '100%' }} />
                          <div className="card-body">
                            <h5 className="card-title">	Compressed Biogas (Bio-CNG)</h5>
                            <p className="card-text">Our biogas meets high purity standards and offers a direct substitute for fossil fuels  in industrial and commercial use.</p>
                            <a href="#contact" className="btn btn-primary">Enquire now</a>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm">
                          <img src={fertilizerImg} className="card-img-top" alt="Biogas Upgradation Unit" loading="lazy" style={{ height: 220, objectFit: 'cover', width: '100%' }} />
                          <div className="card-body">
                            <h5 className="card-title">Organic Manure / Bio-Fertilizer</h5>
                            <p className="card-text">Nutrient-rich digestate from our process becomes 100 % natural fertilizer—enhancing soil health and sustainable farming.</p>
                            <a href="#contact" className="btn btn-primary">Enquire now</a>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm">
                          <img src={tankImg} className="card-img-top" alt="Pressure Regulator Kit" loading="lazy" style={{ height: 220, objectFit: 'cover', width: '100%' }} />
                          <div className="card-body">
                            <h5 className="card-title">	Low-Pressure Mobile Delivery</h5>
                            <p className="card-text">Safe, efficient CBG supply — no storage tanks, no extra CAPEX.</p>
                            <a href="#contact" className="btn btn-primary">Enquire now</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section id="contact">
                  <Contact />
                </section>
              </main>
            </>
          }
        />
        <Route
          path="/services"
          element={
            <div
              style={{
                minHeight: '60vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                padding: '80px 16px'
              }}
            >
              <div>
                <FaTools size={56} color="#1f2d5a" style={{ marginBottom: 16 }} />
                <h2>Services page</h2>
                <p className="text-muted" style={{ maxWidth: 560, margin: '8px auto 16px' }}>
                  This page is under construction. Please check back soon.
                </p>
              </div>
            </div>
          }
        />
        <Route path="/technology-innovation" element={<TechnologyInnovation />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
